import React from "react";
import { Loader2, Search, AlertTriangle, ExternalLink } from "lucide-react";

export const DiscoverHashtagPanel = ({ hashtag, setHashtag, running, result, onRun }) => (
  <div className="bg-gradient-to-br from-violet-50 to-indigo-50 border border-violet-200 rounded-2xl p-5 mb-4" data-testid="doozyad-discover-panel">
    <h3 className="text-sm font-bold text-[#1E1B4B] flex items-center gap-2 mb-1">
      <Search size={16} className="text-violet-600" /> Auto-discover via IG hashtag (Sprint 3b)
    </h3>
    <p className="text-xs text-[#64748B] mb-3">
      Searches Instagram for recent posts under a hashtag, ranks creators by 5K-50K follower band,
      and adds them to your tracker. Powered by Meta Graph API · requires Instagram Public Content Access (App Review).
    </p>
    <div className="flex gap-2 flex-wrap items-center">
      <span className="text-sm text-[#64748B]">#</span>
      <input
        type="text"
        value={hashtag}
        onChange={(e) => setHashtag(e.target.value)}
        placeholder="birthdaydecor, anniversaryparty, indianhomedecor..."
        className="flex-1 min-w-[12rem] px-3 py-2 text-xs border border-gray-200 rounded-xl focus:border-violet-400 outline-none"
        data-testid="doozyad-discover-hashtag-input"
      />
      <button
        onClick={onRun}
        disabled={running || !hashtag.trim()}
        className="px-4 py-2 bg-violet-600 text-white text-xs font-semibold rounded-xl disabled:opacity-50 flex items-center gap-2"
        data-testid="doozyad-discover-run-btn"
      >
        {running ? <><Loader2 size={13} className="animate-spin" /> Searching IG…</> : <><Search size={13} /> Discover</>}
      </button>
    </div>

    {result && (
      <div className="mt-3 text-xs px-3 py-2 rounded-lg" data-testid="doozyad-discover-result">
        {result.status === "ok" ? (
          <div className="bg-white border border-emerald-200 text-emerald-900 px-3 py-2 rounded-lg">
            ✅ <b>{result.added}</b> new creator{result.added !== 1 ? "s" : ""} added
            (screened {result.candidates_screened}, skipped {result.skipped_already_in_tracker} already in tracker).
          </div>
        ) : result.status === "app_review_required" ? (
          <div className="bg-amber-50 border border-amber-200 text-amber-900 p-3 rounded-lg">
            <div className="font-bold mb-1 flex items-center gap-1">
              <AlertTriangle size={13} /> Meta App Review required
            </div>
            <p className="mb-2">{result.explainer}</p>
            <a href={result.review_url} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-xs text-violet-700 underline">
              Open App Review settings <ExternalLink size={11} />
            </a>
            <p className="mt-2 text-[10px] text-amber-700">Permission to request: <code className="bg-amber-100 px-1 rounded">{result.permission_to_request}</code></p>
          </div>
        ) : result.status === "no_hashtag_match" ? (
          <div className="bg-gray-50 border border-gray-200 text-gray-700 px-3 py-2 rounded-lg">No hashtag match — try a more specific term.</div>
        ) : (
          <div className="bg-rose-50 border border-rose-200 text-rose-900 px-3 py-2 rounded-lg">{result.error || result.detail || "Unexpected response"}</div>
        )}
      </div>
    )}
  </div>
);
